import React, { useEffect, useState } from 'react';
import { unstable_batchedUpdates } from 'react-dom';

import { useFormBuilderStore } from '~/src/dash/components/forms/formBuilder/contexts';
import { convertSetIntoSingleNumber } from '~/src/dash/components/forms/formBuilder/ParameterRow/editors/common/common';
import { Col, Cols, IndependentSelectV2, Row, Rows, spacing, Text } from '~/src/dash/publicaUI';

export const GDPRSelect = () => {
  const { object, defaultObject, lists, maintainEditorValuesOnUnmount } = useFormBuilderStore();
  const valueKey = 'TargetingGDPR';
  const selectedOptionIDsArray = [object[valueKey]];

  const consentValueKey = 'TargetingGDPRConsent';
  const selectedConsentIDsArray = [object[consentValueKey]];

  const [gdpr, setGDPR] = useState(object[valueKey]);
  const [_consent, setConsent] = useState(object[consentValueKey]);

  useEffect(() => {
    if (maintainEditorValuesOnUnmount) return;
    return () => {
      object[valueKey] = defaultObject[valueKey];
      object[consentValueKey] = defaultObject[consentValueKey];
    };
  }, [maintainEditorValuesOnUnmount]);

  const handleApplyGDPR = (selectedIDs: Set<number | string>) => {
    const convertedValue = convertSetIntoSingleNumber(selectedIDs as Set<number>);
    unstable_batchedUpdates(() => {
      if (convertedValue !== 2) {
        setConsent(0);
        object[consentValueKey] = defaultObject[consentValueKey];
      }
      setGDPR(convertedValue);
      object[valueKey] = convertedValue;
    });
  };

  const handleApplyConsent = (selectedIDs: Set<number | string>) => {
    const convertedValue = convertSetIntoSingleNumber(selectedIDs as Set<number>);
    setConsent(convertedValue);
    object[consentValueKey] = convertedValue;
  };

  return (
    <Rows gap={spacing.small}>
      <Row noPadding>
        <IndependentSelectV2
          handleApplySelect={handleApplyGDPR}
          isSelectionRequired={true}
          labelTKey='GDPR'
          options={lists.GDPR}
          selectedLimit={1}
          selectedOptionIDs={new Set(selectedOptionIDsArray)}
          key='GDPR'
          selectKey={valueKey}
          disableSort={true}
          maxWidth={480}
        />
      </Row>
      {gdpr === 2 && (
        <Row noPadding>
          <Cols
            gap={spacing.base}
            style={{ justifyContent: 'space-between', alignItems: 'center', width: '480px' }}
          >
            <Col>
              <Text small tKey='GDPRConsent' />
            </Col>
            <Col flex style={{ maxWidth: '480px' }}>
              <IndependentSelectV2
                selectKey={consentValueKey}
                handleApplySelect={handleApplyConsent}
                isSelectionRequired={true}
                labelTKey='GDPRConsentValue'
                options={lists.GDPRConsent}
                selectedLimit={1}
                selectedOptionIDs={new Set(selectedConsentIDsArray)}
                key='GDPRConsent'
                disableSort={true}
                maxWidth={480}
              />
            </Col>
          </Cols>
        </Row>
      )}
    </Rows>
  );
};
